import { NOMEFERMATA_END} from './nomeFermataEndTypes'

const initialState = {
    nomeFermataEnd: ""
}

const nomeFermataEndReducer = (state = initialState, action) => {
    
    switch (action.type) {
        case NOMEFERMATA_END:
            
            return {
                nomeFermataEnd: action.load
            }
    
        default:
          return state
    }

}


export default nomeFermataEndReducer;